import React from 'react';

function ChamadoSubmitButton({ loading, disabled }) {
    return (
        <div className="chamado-create-actions">
            <button
                type="submit"
                className="chamado-create-submit"
                disabled={disabled || loading}
            >
                {loading ? <><span className="sol-spinner" /> Enviando...</> : <><i className="fas fa-paper-plane" /> Criar chamado</>}
            </button>
        </div>
    );
}

export default ChamadoSubmitButton;
